<!-- Risikofaktoren -->
<!-- Nikotin -->
<div class="row">
    <div class="col-md-6">
        <label for="nicr">Nikotin</label><br>
        <label class="radio-inline"><input type="radio" name="nicr" ng-value="true" tabindex="26"
                                           ng-change="vm.save()"
                                           ng-model="vm.risk.nicotin">ja</label>
        <label class="radio-inline"><input type="radio" name="nicr" ng-value="false" tabindex="27"
                                           ng-change="vm.save()"
                                           ng-model="vm.risk.nicotin">nein</label>
    </div>
    <div class="col-md-6">
        <label for="nicotindetails">Nikotin Details</label>
        <vcinput model="vm.risk.nicotindetails" id="nicotindetails" placeholder="Details zum Nikotinkonsum" parentsave="vm.childsave(key, value)"></vcinput>
    </div>
</div>

<!-- Alkohol -->
<div class="row">
    <div class="col-md-6">
        <label for="alcr">Alkohol</label><br>
        <label class="radio-inline"><input type="radio" name="alcr" ng-value="true" tabindex="29"
                                           ng-change="vm.save()"
                                           ng-model="vm.risk.alcohol">ja</label>
        <label class="radio-inline"><input type="radio" name="alcr" ng-value="false" tabindex="30"
                                           ng-change="vm.save()"
                                           ng-model="vm.risk.alcohol">nein</label>
    </div>
    <div class="col-md-6">
        <label for="alcoholdetails">Alkohol Details</label>
        <vcinput model="vm.risk.alcoholdetails" id="alcoholdetails" placeholder="Details zum Alkoholkonsum" parentsave="vm.childsave(key, value)"></vcinput>

    </div>
</div>


<!-- Andere Risiken -->
<div class="row">
    <div class="col-md-6">
        <label for="or">Andere Risiken</label><br>
        <label class="radio-inline"><input type="radio" name="or" ng-value="true" tabindex="32"
                                           ng-change="vm.save()"
                                           ng-model="vm.risk.otherb">ja</label>
        <label class="radio-inline"><input type="radio" name="or" ng-value="false" tabindex="33"
                                           ng-change="vm.save()"
                                           ng-model="vm.risk.otherb">nein</label>
    </div>
    <div class="col-md-6">
        <label for="other">Andere Risiken Details</label>
        <vcinput model="vm.risk.other" id="other" placeholder="Andere Risikofaktoren ..." parentsave="vm.childsave(key, value)"></vcinput>
    </div>
</div>
